import React from "react";
import { VscSend } from "react-icons/vsc";
import { MdAttachFile } from "react-icons/md";

const ChatPrompt = ({
  submitPrompt,
  value,
  handleChange,
  currentMode,
  position,
  placeholder,
  bgOnDark,
  showFileBTn,
  selectFile,
  id,
  mediaPresent
}) => {
  return (
    <div
      className={`flex justify-center px-3 py-2 ${position} w-full bottom-0 z-10 ${
        !currentMode ? `bg-white text-black` : `${bgOnDark} text-white`
      }`}
    >
      <form  onSubmit={submitPrompt} encType='multipart/form-data' className="relative w-full">
        <input
        onClick={(e) => {
          e.stopPropagation()
        }}
          className={`outline-none px-5 py-4 mx-auto w-full rounded-full ${
            !currentMode && `bg-chatTipBackground `
          } text-black border-white`}
          type="text"
          value={value}
          onChange={handleChange}
          name=""
          id=""
          placeholder={placeholder}
        />

          {showFileBTn && 
            <div 
        onClick={(e) => {
          e.stopPropagation()
        }}> 
        <label

         htmlFor={id}>
            <MdAttachFile 
            className={` cursor-pointer inline absolute right-12 bottom-4 text-xl text-black `} />
        </label>
        <input
        onChange={selectFile}
        id={id} type="file" 
        accept="video/*, image/* "
        multiple
        className="hidden" 
         /></div>
          }

        <button
          disabled={(value.length > 0 || mediaPresent) ? false : true}
          type="submit"
          onClick={(e) => {
          e.stopPropagation()
          submitPrompt(e)
        }}
          className={`inline absolute right-3 bottom-4 text-xl
           ${(value.length === 0 && !mediaPresent)? "text-gray-500 cursor-not-allowed" : "text-black" }  `}
        >
        {/* Send icon */}
          <VscSend />
        </button>
      </form>
    </div>
  );
};

export default ChatPrompt;
